export const userSkipsAddonSelection = () => {
  return {
    type: 'User skips add-on selection',
  };
};

export const userContinuesWithAddonSelection = (selectedAddons = []) => ({
  type: 'User continues with add-on selection',
  data: {
    extras_count: selectedAddons.length,
    extras_selected: selectedAddons.map(addon => addon.sku),
  },
});
